import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import type { SanityDocument } from "@sanity/client";


export default /*@__PURE__*/_defineComponent({
  __name: 'terms',
  async setup(__props) {

let __temp: any, __restore: any

definePageMeta({
  layout: "default",
  pageTransition: { name: "page", mode: "out-in" },
});

useHead({
  title: "Terms of Service",
  meta: [{ name: "description", content: "Terms of service FamilyAxis" }],
  bodyAttrs: {
    class: "Terms of Service",
  },
});

defineOgImage("MainOg", {
  title: "Terms of Service - FamilyAxis",
  description: "Understand FamilyAxis’ terms of service.",
  theme: "#f5f5f5",
  colorMode: "light",
});

useSeoMeta({
  title: "Terms of Service | FamilyAxis",
  description: "Read FamilyAxis’ Terms of Service.",
  keywords: "terms of service, FamilyAxis terms",
  author: "FamilyAxis",
  ogTitle: "Terms of Service | FamilyAxis",
  ogDescription: "Our terms of service.",
  ogUrl: "https://familyaxis.com/terms",
  ogType: "website",
  ogSiteName: "FamilyAxis",
  twitterCard: "summary_large_image",
  twitterTitle: "Terms of Service | FamilyAxis",
  twitterDescription: "Read our terms of service.",
  twitterSite: "@familyaxis",
  robots: "index, follow",
});

const POST_QUERY = groq`*[_type == "page" && slug.current == "tos"][0]`;
const { data: post } = (
  ([__temp,__restore] = _withAsyncContext(() => useSanityQuery<SanityDocument>(POST_QUERY))),
  __temp = await __temp,
  __restore(),
  __temp
);

return (_ctx: any,_cache: any) => {
  const _component_UPageHero = _resolveComponent("UPageHero")!
  const _component_ContentSanity = _resolveComponent("ContentSanity")!
  const _component_UPage = _resolveComponent("UPage")!
  const _component_UContainer = _resolveComponent("UContainer")!

  return (_openBlock(), _createBlock(_component_UContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_UPage, { class: "prose px-5 md:px-32 test" }, {
        default: _withCtx(() => [
          _createVNode(_component_UPageHero, {
            title: "Terms of Service",
            description: `Last updated: ${_ctx.formatDateString(_unref(post)._updatedAt)}`
          }, null, 8, ["description"]),
          (_unref(post).body)
            ? (_openBlock(), _createBlock(_component_ContentSanity, {
                key: 0,
                blocks: _unref(post).body,
                page: "terms"
              }, null, 8, ["blocks"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})